<template>
  <div class="ui">
    <div class="py-2" v-if="store_setted">
      <h2 class="header-body-text is-uppercase px-gen">{{ store.setup.name }}</h2>
      <div class="ui grid centered px-gen m-0 info-store">
        <store-data-modal ref="store_data_model" @store_updated="store_updated" />
        <div class="five wide left floated column pl-0">
          <h5 class="ui header fdinpro my-0">
            {{ $t("responsible") }}: {{ store.setup.manager_email }}
          </h5>
          <h5 class="ui header fdinpro my-0">
            {{ $t("email") }}: {{ store.setup.commercial_email }}
          </h5>
          <!-- h5 class="ui header fdinpro my-0">
            {{ $t("phone") }}: {{ store.setup.phone_number }}
          </h5 -->
          <h5 class="ui header fdinpro my-0">
            {{ $t("exchange link") }}:
            <a :href="'/#/nworkforce_exchange/public?i=' + store.store_id" target="_blank"> public = {{ store.store_id }} </a>
          </h5>
          <br />
          <button class="ui button fluid modal-button-green is-uppercase" @click="update_data">
            {{ $t("update data") }}
          </button>
        </div>
        <div class="five wide right floated column pl-0">
          <h5 class="ui header fdinpro my-0" v-for="(usr, usridx) in store.users" :key="usridx">
            {{ $t("user") }}: {{ usr.name }} [{{ usr.username }}]<br><br>
            <button class="ui button fluid modal-button-green is-uppercase" @click="change_password(usr)"> {{ $t("change password") }} </button>
          </h5>
        </div>
      </div>
      <div class="ui grid equal width centered px-gen m-0 info-store">
        <div class="three wide column pl-0">
          <p class="">{{ $t("active systems") }}:</p>
        </div>
        <div class="four wide column pl-0">
          <div class="ui toggle checkbox" ref="api_check">
            <input type="checkbox" name="api" v-model="store.setup.is_api_active" />
              <label>WebService (API)</label>
          </div>
        </div>
        <div class="four wide column pl-0">
          <div class="ui toggle checkbox" ref="exchange_check">
            <input type="checkbox" name="exchange_page" v-model="store.setup.is_exchange_page_active" />
            <label> {{ $t("exchange page") }} </label>
          </div>
        </div>
      </div>
    </div>
    <user-password-modal ref="password_modal" />
    <!-- <pre>{{ store }}</pre> -->
  </div>
</template>

<script>
import { local_api, error_toast, success_toast } from "@/utils";
import StoreDataModal from "./StoreDataModal.vue";
import UserPasswordModal from "./UserPasswordModal.vue";

export default {
  name: "NvidiaTicketNvidiaStoreData",
  components: { StoreDataModal, UserPasswordModal },
  data() {
    return {
      store: {
        setup: { is_api_active: false, is_exchange_page_active: false },
      },
      store_setted: undefined,
    };
  },
  computed: {},
  mounted() {},
  methods: {
    update_store(store) {
      let vm = this;
      vm.store_setted = store;
      vm.is_loading = true;
      local_api(vm, "post", "/nworkforce_nvidia/do-get-store-info", {
        u: store.store_id,
      })
        .then(function(r) {
          vm.$emit("store_data_retrieved", r);
          vm.store = r;

          setTimeout(() => {
            window.jQuery(vm.$refs.api_check).checkbox({
              onChange() {
                local_api(
                  vm,
                  "post",
                  "/nworkforce_nvidia/do-change-store-api",
                  {
                    u: store.store_id,
                    s: vm.store.setup.is_api_active,
                  },
                )
                  .then(function() {
                    success_toast(vm.$t("api status updated"));
                  })
                  .catch(function(err) {
                    error_toast(err);
                  });
              },
            });
            window.jQuery(vm.$refs.exchange_check).checkbox({
              onChange() {
                local_api(
                  vm,
                  "post",
                  "/nworkforce_nvidia/do-change-store-exchange-page",
                  {
                    u: store.store_id,
                    s: vm.store.setup.is_exchange_page_active,
                  },
                )
                  .then(function() {
                    success_toast(vm.$t("exchange page status updated"));
                  })
                  .catch(function(err) {
                    error_toast(err);
                  });
              },
            });
          }, 300);
        })
        .catch(function(err) {
          error_toast(err);
        })
        .finally(() => {
          vm.is_loading = false;
        });
    },
    update_data() {
      let vm = this;
      vm.$refs.store_data_model.set_data(vm.store);
      vm.$refs.store_data_model.do_show();
    },
    store_updated() {
      this.update_store(this.store_setted);
      this.$emit("store_updated");
    },
    change_password(user) {
      this.$refs.password_modal.show(user);
    },
  },
  watch: {
    // "store.setup.is_api_active": function() {
    //   console.log(this.store.setup.is_api_active);
    // },
    // "store.setup.is_exchange_page_active": function() {
    //   console.log(this.store.setup.is_exchange_page_active);
    // },
  },
};
</script>

<style scoped>
/* @import url("https://nworkforce.com/librerias/css/fonts/fonts.css"); */

/*  SPACING   */
.py-2 {
  padding-top: 2rem !important;
  padding-bottom: 2rem !important;
}
.m-0 {
  margin: 0 !important;
}
.my-0 {
  margin-bottom: 0 !important;
  margin-top: 0 !important;
}
.px-gen {
  padding-right: 2rem !important;
  padding-left: 2rem !important;
}
.pl-0 {
  padding-left: 0 !important;
}

/*  FONTS   */
.has-text-centered {
  text-align: center !important;
}
.has-text-left {
  text-align: left !important;
}
.is-uppercase {
  text-transform: uppercase !important;
}
.fdinpro {
  font-family: "DINPro" !important;
}

/*INFO STORE*/
.info-store {
  align-items: center !important;
}
.info-store .six h5 {
  font-size: 90% !important;
}
.info-store .four button {
  flex: 20%;
  text-align: center;
  font-size: 90% !important;
}

/*  MODAL FORMS   */
.default-header-green {
  border-bottom: 2pt solid #365a0c !important;
  font-weight: 300;
  font-size: 1.5rem !important;
}
.modal-button-green {
  background-color: #365a0c !important;
  color: white !important; /*width: 100%;*/
  font-family: "DINPro" !important;
  font-weight: 500;
}
.modal-button-green:hover {
  background-color: rgb(118, 185, 0) !important;
}
</style>
